<div id="gallery">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg inner-card">
                    <h4 class="card-title text-center">Videos</h4>
                    <div class="card-body ">
                        <app-inner-videos [data]="videoList"></app-inner-videos>
                </div>
            </div>
        </div>
    </div>
</div>